export default {
  API: `https://api${process.env.REACT_APP_ENV === 'test' ? '-test' : ''}.lock8.me/api`
}



// WEBPACK FOOTER //
// ./src/constants.js